export default __webpack_public_path__ + "static/media/rating_web-md@2x.784ab12f.jpg";